import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AppWrapper from "../layout/AppWrapper";
import AuthProtectedRoutes from "./AuthProtectedRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import routesList from "./routes";

/**
 *
 * @returns Route
 */
const WrappedRoutes = () => (
  <Routes>
    {routesList.map((Item, _index) =>
      Item.isProtected
        ? ProtectedRoute(Item, _index)
        : SimpleRoute(Item, _index)
    )}
  </Routes>
);

const ProtectedRoute = (Item, _index) => (
  <Route
    key={_index}
    path={Item.path}
    element={
      <ProtectedRoutes>
        <AppWrapper isSidebarShow={Item.isSidebarShow}>
          <Item.Component props={Item} />
        </AppWrapper>
      </ProtectedRoutes>
    }
  />
);

const SimpleRoute = (Item, _index) => (
  <Route
    path={Item.path}
    element={
      <Suspense fallback={<div>Loading...</div>}>
        <AuthProtectedRoutes>
          <Item.Component props={Item} />
        </AuthProtectedRoutes>
      </Suspense>
    }
    key={_index}
  />
);

export default WrappedRoutes;
